<template>
  <div class="m-4">
    <h1 class="text-h1">Administration des versions</h1>
    <PPagination
      :current-page="page"
      :total="versionStore.list.total"
      :page-size="pageSize"
      @change="syncPagination"
      class="mb-1"
      size-selector-position="hidden"
    />
    <div class="flex mb-1 h-6">
      <VersionsAnnouncementForm v-model:updating="updating" @refresh="refresh" class="ml-auto" />
    </div>
    <PTable
      caption=""
      :table="table"
      v-model:selected="selected"
      :sort-by="sortBy"
      @update:sort-by="syncSortBy"
      @click:row="updating = $event"
    >
      <template #column.body="{ row }">
        <ul>
          <li v-for="(item, index) in row.body" :key="index">
            <OhVueIcon :name="dotIcon" scale="1.5" class="pt-1v" />
            {{ item }}
          </li>
        </ul>
      </template>
    </PTable>
    <PPagination
      :current-page="page"
      :total="versionStore.list.total"
      :page-size="pageSize"
      @change="syncPagination"
      class="mt-1"
    />
  </div>
</template>

<script setup lang="ts">
import {
  PTable,
  PPagination,
  usePastaAutoTable,
  type Nullable,
  type PastaTableColumnDefArgs,
  useIcons,
} from "@pasta/box-v2";
import { type VersionAnnouncementDto } from "./version-announcement.dto";
import { ref } from "vue";
import { useVersionAnnouncementStore } from "./version-announcement.store";
import { BiDot } from "oh-vue-icons/icons";
import { OhVueIcon } from "oh-vue-icons";
import VersionsAnnouncementForm from "./versions-announcement-form.vue";
import { useAuthStore } from "@pasta/front-auth-v2";

interface Props {
  page: number;
  pageSize: number;
  urlSearchPattern?: string;
  sortBy?: string;
}

const props = withDefaults(defineProps<Props>(), {
  sortBy: "-id",
  pageSize: 5,
});

const authStore = useAuthStore();

const versionStore = useVersionAnnouncementStore();

const [dotIcon] = useIcons(BiDot);
const updating = ref<Nullable<VersionAnnouncementDto>>(null);

const columns: PastaTableColumnDefArgs<VersionAnnouncementDto>[] = [
  { key: "id", label: "ID", sortable: true, weight: 1 },
  { key: "number", label: "Numéro", sortable: true, weight: 1 },
  { key: "releaseDate", label: "Date", sortable: true, weight: 2 },
  { key: "body", label: "Contenu", weight: 8 },
];

const { table, syncPagination, refresh, syncSortBy, selected } = usePastaAutoTable({
  entityName: "Permission",
  props,
  store: versionStore as any,
  tableDef: {
    columns,
    isClickable: (version: VersionAnnouncementDto) => authStore.ability.can("update", version),
  },
});
</script>
